import { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { notifications } from "../notifications";
import { removeNotification } from "../store/actions/genericActions";
import { AppState } from "../store/definitions";
import { AttachFileDropArea } from "./AttachFileDropArea";
import { ConversationEnded } from "./ConversationEnded";
import Dots from "./Dots";
import { Header } from "./Header";
import { MessageInput } from "./MessageInput";
import { MessageList } from "./MessageList";
import { NotificationBar } from "./NotificationBar";

export const MessagingCanvasPhase = () => {
    const dispatch = useDispatch();
    const conversationState = useSelector((state: AppState) => state.chat.conversationState);
    const chatLoading = useSelector((state: AppState) => state.chat.loading);

    useEffect(() => {
        dispatch(removeNotification(notifications.failedToInitSessionNotification("ds").id));
    }, [dispatch]);

    const Wrapper = conversationState === "active" ? AttachFileDropArea : Fragment;

    return (
        <Wrapper>
            <Header />
            <NotificationBar />
            <MessageList />
            {chatLoading && <Dots />}
            {conversationState === "active" ? <MessageInput /> : <ConversationEnded />}
        </Wrapper>
    );
};
